import { ApiErrorResponse } from '../interfaces/api-error-response.interface';

const DEFAULT_ERROR_MESSAGE = 'An unknown error occurred';

function collectMessagesFromDetail(detail: ApiErrorResponse['error']): string[] {
  if (!detail) {
    return [];
  }

  if (typeof detail === 'string') {
    return detail.trim() ? [detail.trim()] : [];
  }

  if (Array.isArray(detail)) {
    return detail
      .filter((item): item is string => typeof item === 'string')
      .map((item) => item.trim())
      .filter(Boolean);
  }

  const messages: string[] = [];
  Object.values(detail).forEach((value) => {
    if (typeof value === 'string') {
      if (value.trim()) {
        messages.push(value.trim());
      }
    } else if (Array.isArray(value)) {
      messages.push(
        ...value
          .filter((item): item is string => typeof item === 'string')
          .map((item) => item.trim())
          .filter(Boolean),
      );
    } else if (typeof value === 'object' && value !== null) {
      messages.push(...collectMessagesFromDetail(value as ApiErrorResponse['error']));
    }
  });

  return messages;
}

export function getApiErrorMessage(error?: ApiErrorResponse | null): string {
  if (!error) {
    return DEFAULT_ERROR_MESSAGE;
  }

  const detailMessages = collectMessagesFromDetail(error.error);
  if (detailMessages.length > 0) {
    return detailMessages.join('\n');
  }

  if (typeof error.error === 'string' && error.error.trim()) {
    return error.error.trim();
  }

  if (typeof error.message === 'string' && error.message.trim()) {
    return error.message.trim();
  }

  if (typeof error.messages === 'string' && error.messages.trim()) {
    return error.messages.trim();
  }

  return DEFAULT_ERROR_MESSAGE;
}
